import React, { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'

interface SidebarItemProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    title: string
    href: string
    external?: boolean
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ icon: Icon, href, title, external }) => {
    const location = useLocation()
    const isActive = useMemo(() => {
        if (external) return false
        const url = new URL(href, document.location.toString())
        return location.pathname === url.pathname
    }, [location, href, external])

    const className = `w-full pl-6 items-center flex h-[36px] ${isActive ? 'border-r-color-primary border-r-4' : ''}`

    const content = (
        <>
            <div className={`w-[24px] h-[24px] ${isActive ? 'text-color-primary' : 'text-color-base fill-white'}`}>
                {<Icon width={24} height={24}/>}
            </div>
            <div className={`ml-[6px] text-base ${isActive ? 'font-bold' : ''}`}>
                {title}
            </div>
        </>
    )

    if (external) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
                {content}
            </a>
        )
    }

    return (
        <Link to={href} className={className}>
            {content}
        </Link>
    )
}